import { v4 as uuidv4 } from "uuid";

class CryptoUtils {
  static generateUuid() {
    return uuidv4();
  }
}

export default CryptoUtils;
